import util from '@bmp-vue/core/api/util'
const controller = 'Simulacao'
export default Object.assign({}, util.GetCrud(controller, null), {
  EnviarEmail: function (dto) {
    return util.Axios.Post(controller + '/EnviarEmail', dto)
  }
})
